import React, { useState, useContext, useEffect, useRef } from "react";
import api from "../../api/axiosConfig";
import { TfiFilter } from "react-icons/tfi";
import { ProjectContext } from "../../App";
import DateRangePickerComp from "./TodoDateRangePicker";
import { useAuth } from "../Authentication/AuthContext";
import { FaCheckCircle } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";

const FilterTimeSheet = ({
  refresh: refreshTrigger = () => {},
  clearFilter,
}) => {
  const [filters, setFilters] = useState({});
  const [projects, setProjects] = useState([]);
  const [phases, setPhases] = useState(() => {
    const storedPhases = localStorage.getItem("tphases"); // Retrieve from localStorage
    return storedPhases ? JSON.parse(storedPhases) : []; // Parse if exists, else default to empty array
  });
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const { dialBoxopen, isNavBarOpen } = useContext(ProjectContext);
  const { userDetails } = useAuth();
  const userID = userDetails.id;
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [user, setUser] = useState([]);

  const [logUserCondition, setLogUserCondition] = useState(
    () => localStorage.getItem("tlogUserCondition") || "is"
  );
  const [ProjectCondition, setProjectCondition] = useState(
    () => localStorage.getItem("tprojectCondition") || "is"
  );
  const [phaseCondition, setPhaseCondition] = useState(
    () => localStorage.getItem("tphaseCondition") || "is"
  );
  const [billableCondition, setBillableCondition] = useState(
    () => localStorage.getItem("tbillableCondition") || "is"
  );
  const [fromDate, setFromDate] = useState(null); // Updated state for fromDate
  const [toDate, setToDate] = useState(null); // Updated state for toDate
  const [billable, setBillable] = useState(() => {
    // Retrieve from localStorage or default to an empty array
    const savedBillable = localStorage.getItem("tbillable");
    return savedBillable ? JSON.parse(savedBillable) : [];
  });
  const [approvalstatus, setApprovalStatus] = useState(() => {
    // Retrieve from localStorage or default to an empty array
    const savedApprovalStatus = localStorage.getItem("tapprovalstatus");
    return savedApprovalStatus ? JSON.parse(savedApprovalStatus) : [];
  });
  const [loading, setLoading] = useState(true);
  const [logUsersOpen, setLogUserOpen] = useState(true);
  const [projectsOpen, setProjectsOpen] = useState(true);
  const [phaseOpen, setPhaseOpen] = useState(true);
  const [selectedPhase, setSelectedPhase] = useState(() => {
    const storedPhase = localStorage.getItem("tselectedPhase");
    return storedPhase ? JSON.parse(storedPhase) : ""; // Use an empty string instead of [""].
  });
  const [isBillable, setIsBillable] = useState(true);
  const [range, setDateRange] = useState([
    { startDate: new Date(), endDate: new Date() },
  ]);
  const [todoDueDate, setTodoDueDate] = useState(null);

  useEffect(() => {
    if (clearFilter) {
      setSelectedUsers([]);
      setLogUserCondition("is");
      setSelectedProjects([]);
      setProjectCondition("is");
      setSelectedPhase("");
      setPhaseCondition("is");
      setTodoDueDate(null);
      setBillableCondition("is");
      // Clear dropdown search too
      setSearchTerm("");
      setSelectedProjectName("");
    }
  }, [clearFilter]);

  const onClickFilterTimesheet = () => {
    setOpenDialog(true);
    document.body.classList.add("no-scroll");
  };

  const onClosePopUp = () => {
    setOpenDialog(false);
    document.body.classList.remove("no-scroll");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint =
          userDetails.role_name === "Administrator" ||
          userDetails.role_name === "Super Admin"
            ? `/api/projectlistdata`
            : `/api/projectlistdata/${userID}`;

        const [usersRes, projectRes] = await Promise.all([
          api.get(`/api/users`),
          api.get(endpoint),
        ]);
        const activeUsers = usersRes.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        const activeProjects = projectRes.data.filter(
          (project) => project.activestatus === 1
        );
        setProjects(activeProjects);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Load selected users from local storage when the component mounts
    const storedUsers = localStorage.getItem("tselectedUsers");
    const storedProjects = localStorage.getItem("tselectedProjects");
    const storedTask = localStorage.getItem("tselectedTask");
    if (storedUsers) {
      setSelectedUsers(JSON.parse(storedUsers)); // Parse and set users
    }
    if (storedProjects) {
      setSelectedProjects(JSON.parse(storedProjects));
    }
  }, []);

  const fetchPhaseData = async () => {
    const controller = new AbortController();
    try {
      const phasesRes = await api.get(
        `/api/project/${selectedProject}/phasesplannedhours`,
        { signal: controller.signal }
      );
      const phasesData = phasesRes.data?.phases || [];
      // Store in localStorage
      localStorage.setItem("tphases", JSON.stringify(phasesData));
      setPhases(phasesData);
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error fetching phase data:", error);
      }
    } finally {
      setLoading(false);
    }
    return () => controller.abort(); // Cleanup function
  };

  useEffect(() => {
    if (selectedProject && typeof selectedProject === "number") {
      fetchPhaseData();
    }
  }, [selectedProject]);

  useEffect(() => {
    if (selectedProject) {
      fetchPhaseData();
    }
  }, [selectedProject]);

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedProjectName("");

    const filtered = projects.filter((project) => {
      const name = project.name || ""; // Fallback to an empty string
      const projectno = project.projectno || ""; // Fallback to an empty string
      const displayName = project.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        projectno.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredProjects(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };

  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredProjects(projects); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };

  const handleDateRangeChange = (range) => {
    // Parse using the expected format
    const startDate = parse(range.startDate, "dd-MM-yyyy", new Date());
    const endDate = parse(range.endDate, "dd-MM-yyyy", new Date());

    if (!isNaN(startDate) && !isNaN(endDate)) {
      setFromDate(startDate);
      setToDate(endDate);
      setDateRange(startDate, endDate);

      handleApplyFilters(startDate, endDate);
    } else {
      console.error("Invalid date range received", range);
    }
  };

  const handleApplyFilters = (startDate, endDate) => {
    if (user)
      filters.user = { value: selectedUsers, condition: logUserCondition };
    if (selectedProjects)
      filters.selectedProjects = {
        value: selectedProjects,
        condition: ProjectCondition,
      };
    if (selectedPhase)
      filters.selectedPhase = {
        value: selectedPhase,
        condition: phaseCondition,
      };
    const formatDateToLocal = (date) => {
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    };
    if (startDate && endDate) {
      const startDateAdjusted = new Date(startDate);

      startDateAdjusted.setHours(0, 0, 0, 0); // Start of the day

      const endDateAdjusted = new Date(endDate);
      endDateAdjusted.setHours(23, 59, 59, 999); // End of the day

      // Custom function to format date as YYYY-MM-DD without converting to UTC

      filters.dateFilterType = "range";
      filters.fromDate = formatDateToLocal(startDateAdjusted); // Use adjusted start date without timezone issues
      filters.toDate = formatDateToLocal(endDateAdjusted); // Use adjusted end date
    }
    if (todoDueDate) {
      filters.todoDueDate = formatDateToLocal(todoDueDate);
    }
    if (typeof refreshTrigger === "function") {
      refreshTrigger(filters);
    } else {
      console.error("refreshTrigger is not a function");
    }
    onClosePopUp();
  };
  const toggleUserSelection = (user_details) => {
    let updatedUsers;

    if (selectedUsers.includes(user_details.id)) {
      // Remove user if already selected
      updatedUsers = selectedUsers.filter((user) => user !== user_details.id);
    } else {
      // Add user if not selected
      updatedUsers = [...selectedUsers, user_details.id];
    }

    setSelectedUsers(updatedUsers);

    // Save updated selection to local storage
    localStorage.setItem("tselectedUsers", JSON.stringify(updatedUsers));
  };
  const toggleProjectSelection = (p) => {
    fetchPhaseData();
    setSearchTerm("");
    setShowDropdown(false);
    setSelectedProject(p.id);
    let updatedProject;
    // Check if the user is already selected
    if (selectedProjects.includes(p.name)) {
      // Remove user from the selectedUsers array
      updatedProject = selectedProjects.filter(
        (selected) => selected !== p.name
      );
    } else {
      // Add user to the selectedUsers array
      updatedProject = [...selectedProjects, p.name];
    }
    localStorage.setItem("tselectedProjects", JSON.stringify(updatedProject));
    setSelectedProjects(updatedProject);
  };

  useEffect(() => {
    // Save to localStorage whenever billable changes
    localStorage.setItem("tbillable", JSON.stringify(billable));
  }, [billable]);

  return (
    <div>
      <div>
        <div
          className="date-range-todo span-input-todo"
          value={
            range[0] && range[0].startDate && range[0].endDate
              ? `${format(range[0].startDate, "MM-dd-yyyy")} to ${format(
                  range[0].endDate,
                  "MM-dd-yyyy"
                )}`
              : "Select a date range"
          }
        >
          <span>
            <DateRangePickerComp
              onDateRangeChange={handleDateRangeChange}
              clearFilter={clearFilter}
            />
          </span>
        </div>
        <button
          onClick={onClickFilterTimesheet}
          style={{
            border: "none",
            position: "absolute",
            right: "1rem",
            zIndex: "9",
            top: "0.5rem",
          }}
        >
          <TfiFilter
            title="Filter"
            className={
              isNavBarOpen ? "todo-filter-btn" : "todo-filter-btn-close"
            }
            style={{ zIndex: "9" }}
          />
        </button>
      </div>

      {openDialog && (
        <div className={`filter-dial  ${dialBoxopen ? "open" : "close"}`}>
          <div className="filter-overview-con">
            <div className="new-time-log">
              <h3
                style={{
                  backgroundColor: "transparent",
                  marginLeft: "10px",
                  marginTop: "5px",
                }}
              >
                Filter Options
              </h3>
            </div>
            <div className="overview-filter-scrollable-t-content">
              {(userDetails.role_name === "Administrator" ||
                userDetails.role_name === "Project_Manager" ||
                userDetails.role_name === "Super Admin") && (
                <div
                  className={
                    logUsersOpen ? "accordion-u-header" : "accordion-header"
                  }
                  style={{ marginBottom: "-1px", borderTop: "none" }}
                >
                  <h3
                    className="accordion-label"
                    onClick={() => setLogUserOpen((prev) => !prev)}
                  >
                    Users
                    {selectedUsers.length > 0 && (
                      <span className="users-count">
                        {selectedUsers.length}
                      </span>
                    )}
                  </h3>

                  {!logUsersOpen && (
                    <select
                      className="is-not"
                      value={logUserCondition}
                      onChange={(e) => {
                        setLogUserCondition(e.target.value);
                        localStorage.setItem(
                          "tlogUserCondition",
                          e.target.value
                        );
                      }}
                    >
                      <option value="is">Is</option>
                      <option value="not">Is Not</option>
                    </select>
                  )}
                  <span
                    onClick={() => setLogUserOpen((prev) => !prev)}
                    className="span-element"
                  >
                    {logUsersOpen ? (
                      <FaChevronRight className="arrow-icon" />
                    ) : (
                      <FaChevronDown className="arrow-d-icon" />
                    )}
                  </span>
                </div>
              )}
              {(userDetails.role_name === "Administrator" ||
                userDetails.role_name === "Project_Manager" ||
                userDetails.role_name === "Super Admin") && (
                <div
                  className={logUsersOpen ? "hide" : "filter-name-field"}
                  style={{
                    height:
                      userDetails.role_name === "Administrator" ||
                      userDetails.role_name === "Super Admin"
                        ? "133px"
                        : "auto",
                  }}
                >
                  {userDetails.role_name === "Administrator" ||
                  userDetails.role_name === "Project_Manager" ||
                  userDetails.role_name === "Super Admin" ? (
                    <ul className="user-ul">
                      {users
                        .sort((a, b) => a.name.localeCompare(b.name)) // Sort users alphabetically by name
                        .map((user_details) => (
                          <li
                            key={user_details.id}
                            onClick={() => toggleUserSelection(user_details)} // Pass correct user object
                            className={"user-name-list"}
                          >
                            <span className="initial">
                              {selectedUsers.includes(user_details.name) ? (
                                <FaCheckCircle
                                  style={{ backgroundColor: "transparent" }}
                                />
                              ) : (
                                user_details.name
                                  .charAt(user_details.name.length - 1)
                                  .toUpperCase() +
                                user_details.name.charAt(0).toUpperCase()
                              )}
                            </span>{" "}
                            <span
                              style={{
                                backgroundColor: "transparent",
                                marginTop: "2px",
                              }}
                            >
                              {user_details.name}
                            </span>
                          </li>
                        ))}
                    </ul>
                  ) : (
                    <ul className="users-ul">
                      <li
                        key={userDetails.id}
                        onClick={() => toggleUserSelection(userDetails)} // Pass correct user object
                        className={"user-name-list"}
                      >
                        <span className="initial">
                          {selectedUsers.includes(userDetails.name) ? (
                            <FaCheckCircle
                              style={{ backgroundColor: "transparent" }}
                            />
                          ) : (
                            userDetails.name
                              .charAt(userDetails.name.length - 1)
                              .toUpperCase() +
                            userDetails.name.charAt(0).toUpperCase()
                          )}
                        </span>{" "}
                        <span
                          style={{
                            backgroundColor: "transparent",
                            marginTop: "2px",
                          }}
                        >
                          {userDetails.name}
                        </span>
                      </li>
                    </ul>
                  )}
                </div>
              )}
              <div
                className={
                  projectsOpen ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginBottom: "-1px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setProjectsOpen((prev) => !prev)}
                >
                  Projects{" "}
                  {selectedProjects.length > 0 && (
                    <span className="users-count">
                      {selectedProjects.length}
                    </span>
                  )}
                </h3>
                {!projectsOpen && (
                  <select
                    className="is-not"
                    value={ProjectCondition}
                    onChange={(e) => {
                      setProjectCondition(e.target.value);
                      localStorage.setItem("tprojectCondition", e.target.value);
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setProjectsOpen((prev) => !prev)}
                  className="span-element"
                >
                  {projectsOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className={projectsOpen ? "hide" : "filter-name-field"}>
                <div className="filter-project-search">
                  <input
                    ref={dropdownRef}
                    className="filter-p-input"
                    placeholder="Search Projects"
                    value={searchTerm || selectedProjectName}
                    onChange={handleSearchChange}
                    onFocus={handleFocus}
                    onMouseDown={() => handleClickOutside}
                  />
                  {showDropdown &&
                    (showDropdown && filteredProjects?.length > 0 ? (
                      <ul
                        style={{ zIndex: "50" }}
                        ref={dropdownRef}
                        className="project-display-box-overview"
                      >
                        {filteredProjects
                          .sort((a, b) => {
                            const isSelectedA = selectedProjects.includes(
                              a.name
                            )
                              ? -1
                              : 1;
                            const isSelectedB = selectedProjects.includes(
                              b.name
                            )
                              ? -1
                              : 1;
                            return isSelectedA - isSelectedB;
                          })
                          .map((project) => (
                            <li
                              key={project.id}
                              value={project.id}
                              onClick={() => toggleProjectSelection(project)}
                              onMouseDown={() => handleClickOutside}
                              className="project-dropdown-item"
                              style={{
                                color: selectedProjects.includes(project.name)
                                  ? "#6200ee"
                                  : "black",
                              }}
                            >
                              {project.projectno}-{project.name}
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <p>No Projects available</p>
                    ))}
                </div>
              </div>
              {selectedProjects.length > 0 && (
                <>
                  <div
                    className={
                      !phaseOpen ? "accordion-u-header" : "accordion-header"
                    }
                    style={{ marginBottom: "-1px" }}
                  >
                    <h3
                      className="accordion-label"
                      onClick={() => setPhaseOpen((prev) => !prev)}
                    >
                      Phase
                      {selectedPhase.length > 0 && (
                        <span className="users-count">
                          {selectedPhase.length > 0 ? 1 : 0}
                        </span>
                      )}
                    </h3>
                    {phaseOpen && (
                      <select
                        className="is-not"
                        value={phaseCondition}
                        onChange={(e) => {
                          setPhaseCondition(e.target.value);
                          localStorage.setItem(
                            "tphaseCondition",
                            e.target.value
                          );
                        }}
                      >
                        <option value="is">Is</option>
                        <option value="not">Is Not</option>
                      </select>
                    )}
                    <span
                      onClick={() => setPhaseOpen((prev) => !prev)}
                      className="span-element"
                    >
                      {!phaseOpen ? (
                        <FaChevronRight className="arrow-icon" />
                      ) : (
                        <FaChevronDown className="arrow-d-icon" />
                      )}
                    </span>
                  </div>
                  {phaseOpen && (
                    <div>
                      <select
                        className="overview-phase-dd"
                        value={selectedPhase}
                        onChange={(e) => {
                          const phaseValue = e.target.value;
                          setSelectedPhase(phaseValue);
                          localStorage.setItem(
                            "tselectedPhase",
                            JSON.stringify(phaseValue)
                          ); // Store as a string
                        }}
                      >
                        <option disabled value="">
                          Select Phase
                        </option>
                        {phases.map((phase) => (
                          <option key={phase.phase_id} value={phase.title}>
                            {phase.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </>
              )}
              <div
                className={
                  isBillable ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginBottom: !isBillable ? "0px" : "-23px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setIsBillable((prev) => !prev)}
                >
                  Due Date
                  {billable.length > 0 && (
                    <span className="users-count">{billable.length}</span>
                  )}
                </h3>
                {!isBillable && (
                  <select
                    className="is-not"
                    value={billableCondition}
                    onChange={(e) => {
                      setBillableCondition(e.target.value);
                      localStorage.setItem(
                        "tbillableCondition",
                        e.target.value
                      );
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}
                <span
                  onClick={() => setIsBillable((prev) => !prev)}
                  className="span-element"
                >
                  {isBillable ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className="filter-field">
                <div
                  className={isBillable ? "hide" : "filter-billing-checkbox"}
                >
                  <DatePicker
                    selected={todoDueDate}
                    onChange={(date) => setTodoDueDate(date)}
                    className="todo-p-input"
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="overview-filter-btn-container-add-timesheet">
              <button
                className="add-btn"
                onClick={handleApplyFilters}
                style={{ marginLeft: "5px", fontWeight: "600px" }}
              >
                Apply
              </button>
              <button
                onClick={onClosePopUp}
                className="cancel-btn"
                style={{ fontWeight: "600px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterTimeSheet;
